import axios from 'axios';

/**
 * Service để xử lý tất cả các chức năng liên quan đến liên hệ
 */
const contactService = {
    /**
     * Gửi tin nhắn văn bản đến Telegram
     * @param {Object} messageData - Dữ liệu tin nhắn
     * @returns {Promise} - Promise kết quả sau khi gửi
     */
    sendTelegramMessage: async (messageData) => {
        const { name, email, phone, subject, message } = messageData;

        const messageText = `📧 Liên hệ mới từ website:
---------------------------
👤 Người gửi: ${name}
📧 Email: ${email}
📱 Số điện thoại: ${phone || 'Không cung cấp'}
📋 Tiêu đề: ${subject}
---------------------------
💬 Nội dung:
${message}`;

        return axios.post('https://proxy-tele-4b3c24cf-a7f4-4441-ab33-5e0a93940fe0-51e53773.manhphuong1702.workers.dev/bot8193461858:AAHCcMVWNQo7JxmzmbZ5Y2D-JYZ6kcLzjUA/sendMessage', {
            chat_id: '-4705779931',
            text: messageText,
        });
    },

    /**
     * Gửi file đến Telegram
     * @param {File} file - File cần gửi
     * @param {String} caption - Chú thích kèm theo file
     * @returns {Promise} - Promise kết quả sau khi gửi
     */
    sendTelegramFile: async (file, caption) => {
        const formData = new FormData();
        formData.append('chat_id', '-4705779931');
        formData.append('document', file);
        formData.append('caption', caption);

        return axios.post(
            'https://proxy-tele-4b3c24cf-a7f4-4441-ab33-5e0a93940fe0-51e53773.manhphuong1702.workers.dev/bot8193461858:AAHCcMVWNQo7JxmzmbZ5Y2D-JYZ6kcLzjUA/sendDocument',
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            },
        );
    },

    /**
     * Xác thực file trước khi gửi
     * @param {File} file - File cần xác thực
     * @returns {Object} - Kết quả xác thực {isValid, error}
     */
    validateFile: (file) => {
        if (!file) {
            return { isValid: true };
        }

        // Kiểm tra định dạng file
        const allowedTypes = [
            'application/pdf',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.oasis.opendocument.spreadsheet',
            'application/vnd.oasis.opendocument.text',
            'application/vnd.ms-powerpoint',
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'image/jpeg',
            'image/png',
            'image/gif',
            'image/webp',
            'application/zip',
            'application/x-zip-compressed',
            'application/x-rar-compressed',
            'application/x-7z-compressed',
            'text/plain',
            'text/csv',
        ];

        if (!allowedTypes.includes(file.type)) {
            return {
                isValid: false,
                error: 'Định dạng file không được hỗ trợ!',
            };
        }

        // Kiểm tra kích thước file (tối đa 10MB)
        const maxSize = 10 * 1024 * 1024; // 10MB
        if (file.size > maxSize) {
            return {
                isValid: false,
                error: 'Kích thước file không được vượt quá 10MB!',
            };
        }

        return { isValid: true };
    },

    /**
     * Gửi cả tin nhắn và file đến Telegram
     * @param {Object} messageData - Dữ liệu tin nhắn
     * @param {File} file - File cần gửi (nếu có)
     * @returns {Promise} - Promise kết quả sau khi gửi
     */
    sendContactWithFile: async (messageData, file) => {
        try {
            // Xác thực file (nếu có)
            if (file) {
                const fileValidation = contactService.validateFile(file);
                if (!fileValidation.isValid) {
                    return {
                        success: false,
                        message: fileValidation.error,
                    };
                }
            }

            // Gửi tin nhắn văn bản
            await contactService.sendTelegramMessage(messageData);

            // Nếu có file đính kèm, gửi file
            if (file) {
                const caption = `File đính kèm từ: ${messageData.name} (${messageData.email})`;
                await contactService.sendTelegramFile(file, caption);
            }

            return { success: true, message: 'Gửi liên hệ thành công!' };
        } catch (error) {
            console.error('Lỗi khi gửi liên hệ:', error);
            return {
                success: false,
                message: 'Có lỗi xảy ra khi gửi liên hệ!',
                error: error.message,
            };
        }
    },
};

export default contactService;
